import { InfoOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

const NoDataState = ({ message }: { message: string }) => (
    <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            p: 4,
            bgcolor: '#f8f9fa',
            borderRadius: 3,
            border: '1px dashed #e0e0e0'
        }}
    >
        <InfoOutlined sx={{ color: 'text.disabled', mb: 1, fontSize: 32 }} />
        <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
            {message}
        </Typography>
    </Box>
);

export default NoDataState;